const imgTeamMain = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingAiMain2 = "./assets/figma/52a8fd9d-db80-4ff0-a4d5-66c04e7ab394.png";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgMixball1 = "./assets/figma/9997796b-fda8-421c-a727-87c020879573.svg";
const imgMixball3 = "./assets/figma/e3fd4538-c1d6-4e4d-b4c1-9ed8ca0639a3.svg";
const imgMixball2 = "./assets/figma/8090d012-8df9-4a94-8f4e-40bc98c7a606.svg";
const img1 = "./assets/figma/10c9e57a-3d9e-46bd-aa90-dd15d7868e23.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamMain() {
  return (
    <div className="s0 s1" data-node-id="772:446" data-name="TEAM_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s1068 s1" src={imgTeamMain} />
      </div>
      <div className="s2 s1069 s1070 s1071 s1072" data-node-id="886:10" data-name="DING_AI_MAIN 1" />
      <div className="s2 s1073 s103 s10 s104" data-node-id="772:447" data-name="main5 1" />
      <div className="s2 s267 s268 s269 s270" data-node-id="772:453" data-name="image 14" />
      <div className="s259 s2 s16 s17 s24 s1074 s18 s19 s466 s1075 s273 s274 s275 s276 s145 s146 s261 s278" data-node-id="772:474" data-name="AI RECIPE">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="772:475">
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s34" data-node-id="772:476">
            ai recipe
          </p>
          <div className="s46 s0 s28 s34" data-node-id="772:477">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <div className="s2 s1076 s299 s1077" data-node-id="772:478" data-name="MIXBALL1">
          <div className="s2 s300">
            <img alt="" className="s49 s9 s1" src={imgMixball1} />
          </div>
        </div>
        <div className="s2 s1078 s299 s1079" data-node-id="772:480" data-name="MIXBALL3">
          <div className="s2 s300">
            <img alt="" className="s49 s9 s1" src={imgMixball3} />
          </div>
        </div>
        <div className="s2 s1080 s299 s1081" data-node-id="772:479" data-name="MIXBALL2">
          <div className="s2 s300">
            <img alt="" className="s49 s9 s1" src={imgMixball2} />
          </div>
        </div>
        <div className="s16 s17 s24 s1082 s26 s0 s28 s297" data-node-id="1041:24">
          <div className="s16 s17 s18 s0 s28 s34" data-node-id="1041:25">
            <div className="s23 s35 s1083 s36 s27 s0 s28 s29 s281 s1084 s38" data-node-id="1041:26">
              <p className="s1085 s32 s40">READY TO MIX</p>
              <p className="s32 s40">​</p>
              <p className="s32 s40">SELECT A TEAM TO</p>
              <p className="s32">REVEAL IT’S AI RECIPE</p>
            </div>
          </div>
        </div>
        <div className="s2 s3 s4 s150 s151" />
      </div>
      <div className="s106 s259 s2 s126 s260 s261" data-node-id="1028:469" data-name="DING_AI_MAIN 2">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingAiMain2} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1035:664" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="1035:665">
          <div className="s111 s0 s28 s112" data-node-id="1035:666" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1035:671">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1035:672">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1035:673">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:674">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:675">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="1035:676">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:677">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:678">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <a className="s16 s141 s17 s24 s118 s18 s0 s28 s124" data-node-id="1035:679">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:680">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:681">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </a>
        </div>
      </div>
      <div className="s259 s2 s16 s141 s17 s24 s230 s26 s303 s277 s304" data-node-id="1062:156" data-name="TAB_TEAM">
        <a className="s16 s17 s305 s18 s306 s307 s464 s309 s0 s145 s146 s28 s34" data-node-id="772:461" data-name="TAB_TEAM_GRAPHIC1">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="772:462">
            GRAPHIC 1
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s34" data-node-id="1062:161" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="1062:162">
            GRAPHIC 2
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s146 s28 s34" data-node-id="1062:163" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s314 s18 s19 s0 s28 s315" data-node-id="1062:164">
            <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1062:165">
              UI/UX
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s305 s18 s311 s307 s316 s309 s0 s145 s146 s28 s34" data-node-id="1062:166" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1062:167">
            PACKAGE
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s17 s305 s18 s306 s307 s317 s309 s0 s145 s146 s28 s34" data-node-id="1062:168" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1062:169">
            MOTION
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
      </div>
    </div>
  );
}